import { useColorModeValue } from "@chakra-ui/react";
import { NFTEvent } from "@models/event";
import { MS_END } from "@models/timezone";
import Countdown from "react-countdown";

const _t = (key?: string) => key || "";

const CountdownCard = ({ title, value }: { title: string; value: string }) => {
  const bgColor = useColorModeValue("", "bg-glass");
  return (
    <div
      className={`flex flex-col items-center justify-center shadow-md text-countdown rounded-lg bg-white ${bgColor} flex-grow p-4`}
    >
      <div className="sm:text-3xl text-2xl font-bold">{value}</div>
      <div className="text-base font-medium text-black dark:text-white mt-2">
        {title}
      </div>
    </div>
  );
};

const CountdownCardContainer = ({
  days,
  hours,
  minutes,
  seconds,
}: {
  days: string;
  hours: string;
  minutes: string;
  seconds: string;
}) => {
  return (
    <div className="grid grid-cols-2 gap-2 @sm:gap-3 @xs:grid-cols-4 w-full">
      <CountdownCard title={_t("Days")} value={days} />
      <CountdownCard title={_t("Hours")} value={hours} />
      <CountdownCard title={_t("Mins")} value={minutes} />
      <CountdownCard title={_t("Secs")} value={seconds} />
    </div>
  );
};

const renderer = ({ days, hours, minutes, seconds, completed }) => {
  if (completed) {
    return <></>;
  } else {
    return (
      <CountdownCardContainer
        days={days}
        hours={hours}
        minutes={minutes}
        seconds={seconds}
      />
    );
  }
};

const EventDetailCountdown = ({ event }: { event: NFTEvent }) => {
  let date = Date.now();
  let countdownText = "";

  const tier = event.tiers[0];
  if (
    !tier?.paymentConfig || // Non-paid event
    (date > event.start && event.start > 0) || // Event already started
    date > event.end // Event already ended
  )
    return <></>;

  if (date > tier.paymentConfig.end) {
    // Sales closed, count towards event start
    date = event.start;
    countdownText = "Event starts in";
  } else {
    if (tier.paymentConfig.start <= 0) {
      // Sales period forever, count towards event start
      date = event.start;
      countdownText = "Event starts in";
    } else {
      if (tier.paymentConfig.start > date) {
        // Sales not started, count towards sales start
        date = tier.paymentConfig.start;
        countdownText = "Sale starts in";
      } else {
        // Sales started
        if (tier.paymentConfig.end === MS_END) {
          // Sales period forever, count towards event start
          date = event.start;
          countdownText = "Event starts in";
        } else if (tier.paymentConfig.end > date) {
          // Sales ending in future, count towards sales end
          date = tier.paymentConfig.end;
          countdownText = "Sale closes in";
        } else {
          // Sales ended, count towards event start
          date = event.start;
          countdownText = "Event starts in";
        }
      }
    }
  }

  if (date <= 0) return <></>;
  return (
    <div className="my-4 flex flex-col gap-3 w-full @container">
      <div className="text-base">{countdownText}</div>
      <Countdown date={date} renderer={renderer} />
    </div>
  );
};

export default EventDetailCountdown;
